(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
constructor() {
super();

const handleIntersection = (entries, observer) => {
if (!entries[0].isIntersecting) return;
observer.unobserve(this);

fetch(this.dataset.url)
.then(response => response.text())
.then(text => {
const html = document.createElement('div');
html.innerHTML = text;
const recommendations = html.querySelector('product-recommendations');

if (recommendations && recommendations.innerHTML.trim().length) {
this.innerHTML = recommendations.innerHTML;
}

if (html.querySelector('.grid__item')) {
this.classList.add('product-recommendations--loaded');
$('.product-grid').slick({
slidesToShow: 5,
slidesToScroll: 1,
arrows: true,
infinite:false,
responsive: [
{
breakpoint: 1560,
settings: {
slidesToShow: 4,
slidesToScroll: 1,
infinite: false,
arrows:true,
}
},
{
breakpoint: 900,
settings: {
slidesToShow: 3,
slidesToScroll: 1,
infinite: false,
arrows:true
}
},
{
breakpoint: 750,
settings: {
slidesToShow: 2,
slidesToScroll: 1,
infinite: false,
arrows: false,
dots:true
}
},

{
breakpoint: 481,
settings: {
slidesToShow: 1,
slidesToScroll: 1,
infinite: false,
arrows: false,
dots:true
}
}
]


});
}
})
.catch(e => {
console.error(e);
});
}

new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
}
}

customElements.define('product-recommendations', ProductRecommendations);





  } catch(e) { console.error(e); }
})();
})();
